import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { RouterModule } from '@angular/router'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'

@Component({
  selector: 'ddc-button-r-one',
  templateUrl: './ddc-button-r-one.component.html',
  styleUrls: ['./ddc-button-r-one.component.scss'],
  imports: [AngularMaterialsModules, CommonModule, RouterModule],
})
export class DdcButtonROneComponent {
  @Input() label: string
  @Input() dynamicRoute: string
  @Input() icon: string
  @Input() type: string

  constructor(private logger: DdcLoggerService) {}
}
